import { UseQueryResult } from '@tanstack/react-query'
import { Dispatch, SetStateAction, useEffect } from 'react'

export const useQueriesFetched = <T,>(
  queries: UseQueryResult<T | undefined, unknown>[],
  setReportIsGenerated: Dispatch<SetStateAction<boolean>>
) => {
  useEffect(() => {
    if (queries && queries.length > 0) {
      const isLoading = queries.some(
        (response) => response.isLoading || response.isFetching
      )

      // If we have data and queries are done loading, mark report as generated
      const hasData = queries.some(
        (response) =>
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0
      )

      // Only set reportIsGenerated to true when actively loading or when we have data
      setReportIsGenerated(isLoading || hasData)
    }
  }, [queries, setReportIsGenerated])
}
